<script lang="ts">
  // Portal Pill — a thin ADAPTER over the shared shadcn-svelte Badge
  // (@price-check/ui). Keeps the portal's tone vocabulary (indigo/slate/ok/danger/
  // amber) + its `data-tone` marker (tests + styling), but rendering + status
  // colors now come from the shared Badge variants. NO arbitrary `[..]` values.
  import type { Snippet } from "svelte";
  import { Badge, type BadgeVariant } from "@price-check/ui";

  let {
    tone = "slate",
    children,
  }: {
    tone?: "indigo" | "slate" | "ok" | "danger" | "amber";
    children: Snippet;
  } = $props();

  const VARIANT: Record<string, BadgeVariant> = {
    indigo: "brand-soft",
    slate: "muted",
    ok: "success",
    danger: "danger",
    amber: "warning",
  };
  // The shared `muted` variant is borderless; the slate pill historically showed a
  // hairline border, so re-assert one for that tone only.
  const extra = $derived(tone === "slate" ? "border-border" : "");
</script>

<Badge variant={VARIANT[tone]} data-tone={tone} class="capitalize font-semibold {extra}">
  {@render children()}
</Badge>
